module.exports = __webpack_public_path__ + "img/logo-travel.2ce33b15.png";